<template>
  <content-panel>
    <table-panel ref="tablePanel">
      <template v-slot:header-left>
        <el-button type="primary" size="small" @click="handleAdd(null, 1)">新增</el-button>
      </template>
      <el-table
        stripe
        v-loading="loading"
        ref="tableRef"
        highlight-current-row
        border
        :data="tableData"
        :height="maxTableHeight">
        <el-table-column prop="sortNo" label="排序号" align="center" width="100"></el-table-column>
        <el-table-column prop="dictDataCode" label="数据编码" show-overflow-tooltip ></el-table-column>
        <el-table-column prop="dictDataValue" label="数据值"  show-overflow-tooltip></el-table-column>
        <el-table-column prop="dataDesc" label="数据描述" align="center" show-overflow-tooltip ></el-table-column>
         <el-table-column prop="updatedBy" label="更新人"  width="150" align="center"></el-table-column>
        <el-table-column prop="updatedTime" label="更新时间" width="150" align="center">
          <template slot-scope="scope">
            {{scope.row.updatedTime | dateFormat}}
          </template>
        </el-table-column>
        <el-table-column prop="status" label="状态" width="80" align="center">
          <template slot-scope="scope">
            {{scope.row.status | statusEnum}}
          </template>
        </el-table-column>
        <el-table-column  label="操作" width="180" class-name="action-column" align="center">
          <template v-slot="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button v-if="scope.row.status == 1" type="text" size="small" @click="handleState(scope.row, 0)">启用</el-button>
            <el-button v-else type="text" size="small" @click="handleState(scope.row, 1)">禁用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </table-panel>
    <add-dialog 
      :isNewAddPopup.sync="isNewAddPopup"
      v-if="isNewAddPopup"
      :formItems="dictDetailsFormItems"
      :editData.sync='editData'
      @onConfirm="onConfirm"
      InputWidth="100%"
      :title="editData.operationType == 'add' ? '新增':'编辑'"
    />
  </content-panel>
</template>

<script>
import tableMixin from '@/utils/tableMixin';
import pagePathMixin from '@/utils/page-path-mixin'
import addDialog from '../add-dialog'
import { dictDetailsFormItems } from '../config'
export default {
  mixins: [tableMixin,pagePathMixin],
  components: {
    addDialog
  },
  data() {
    return {
      // 表格相关
      tableData: [],
      selection: [],
  
      loading: false,
      isNewAddPopup: false,
      dictDetailsFormItems,
      editData: {
        sortNo: '',
        typeCode: '',
        dictDataValue: '',
        extendField: '',
        dataDesc: ''
      }
    }
  },
  computed: {
    typeCode() {
      return this.$route.query.typeCode
    }
  },
  methods: {
    init() {
      this.editData.typeCode = this.typeCode
      this.getList();
    },
    getList() {
      this.loading = true;
      this.$api.configure.getDictDataAll(this.typeCode)
        .then((res) => {
          this.tableData = res.data
        })
        .finally(() => {
          this.loading = false;
        });
    },
   
    handleAdd() {
      this.editData = {
        sortNo: '',
        typeCode: this.typeCode,
        dictDataValue: '',
        extendField: '',
        dataDesc: '',
        operationType: 'add'
      }
      this.isNewAddPopup = true
    },
    handleEdit(row) {
      this.editData = {...row}
      this.editData.operationType = 'update'
      this.isNewAddPopup = true
    },
    handleState(row, state) {
      this.$api.configure
        .updateDictDataStatus(row.dictId, state)
        .then(({data}) => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.getList();
        });
    },
    onConfirm() {
      this.$api.configure.saveOrUpdateDictData(this.editData)
        .then(res => {
          if (res.success) {
             this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.isNewAddPopup = false
            this.init()
            // this.editData ={}
          }
        })
    },
  },
  filters: {
    statusEnum(val) {
      const map = {
        0: '启用',
        1: '禁用'
      };
      return map[val] || '';
    },
  },
  created() {
    this.init();
  }
}
</script>

<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>